import { Alert, Empty, Form, Spin } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import InsuranceProductAccordion from "../shared/InsuranceProductAccordion";

const SelectProductStep = ({
    products,
    productsLoading,
    selectedProductId,
    onSelectProduct,
    quote,
    quoteLoading,
    quoteError,
    locationSelected,
    carSelected,
    isLocationCoveredForProvider,
    carWorthValue,
}) => {
    const { t } = useTranslation("sellInsurance");

    const showPrerequisitesMessage =
        !locationSelected || !carSelected || !isLocationCoveredForProvider;

    return (
        <div className="space-y-4">
            <Form.Item
                name="insuranceId"
                rules={[{ required: true, message: t("wizard.productRequired") }]}
                className="mb-0">
                <input type="hidden" />
            </Form.Item>

            {showPrerequisitesMessage && (
                <Alert
                    type="info"
                    showIcon
                    message={
                        !locationSelected
                            ? t("wizard.selectLocationFirst")
                            : !isLocationCoveredForProvider
                              ? t("wizard.locationNotCoveredTitle")
                              : t("wizard.selectVehicleFirst")
                    }
                    description={
                        !isLocationCoveredForProvider ? t("wizard.locationNotCoveredDescription") : undefined
                    }
                />
            )}

            {productsLoading && (
                <div className="flex justify-center py-8">
                    <Spin />
                </div>
            )}

            {!productsLoading && !showPrerequisitesMessage && products.length === 0 && (
                <Empty description={t("wizard.noProducts")} />
            )}

            {!productsLoading && !showPrerequisitesMessage && products.length > 0 ? (
                <InsuranceProductAccordion
                    products={products}
                    selectedProductId={selectedProductId}
                    onSelectProduct={onSelectProduct}
                    quote={quote}
                    quoteLoading={quoteLoading}
                    carWorthValue={carWorthValue}
                />
            ) : null}

            {quoteError && !quoteLoading && (
                <Alert type="error" showIcon message={t("wizard.quoteError")} description={quoteError} />
            )}
        </div>
    );
};

SelectProductStep.propTypes = {
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    productsLoading: PropTypes.bool,
    selectedProductId: PropTypes.string,
    onSelectProduct: PropTypes.func.isRequired,
    quote: PropTypes.object,
    quoteLoading: PropTypes.bool,
    quoteError: PropTypes.string,
    locationSelected: PropTypes.bool,
    carSelected: PropTypes.bool,
    isLocationCoveredForProvider: PropTypes.bool,
    carWorthValue: PropTypes.number,
};

SelectProductStep.defaultProps = {
    productsLoading: false,
    selectedProductId: undefined,
    quote: null,
    quoteLoading: false,
    quoteError: null,
    locationSelected: false,
    carSelected: false,
    isLocationCoveredForProvider: true,
    carWorthValue: undefined,
};

export default SelectProductStep;
